module.exports = __webpack_public_path__ + "static/media/Chimchar_gaussian2.63b5426e.png";